import React from "react";

import {
  AssignerButtonsContainer,
  AssignIcon,
  Button,
  UnassignIcon,
} from "./styles";

export type FunctionAssignerButtonsProps = {
  selectFocused: () => void;
  unselectFocused: () => void;
};

const FunctionAssignerButtons = ({
  selectFocused,
  unselectFocused,
}: FunctionAssignerButtonsProps) => (
  <AssignerButtonsContainer data-cy="assigner-buttons-container">
    <Button type="button" onClick={selectFocused} data-cy="move-right-icon">
      <AssignIcon />
    </Button>
    <Button type="button" onClick={unselectFocused} data-cy="move-left-icon">
      <UnassignIcon />
    </Button>
  </AssignerButtonsContainer>
);

export default FunctionAssignerButtons;
